
    const cont = await (window.__arboritoShellGate || Promise.resolve(true));
    if (!cont) await new Promise(() => {});
    await import('./src/main.jsx');
  